"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OktonForgotPassword = exports.OktonAuthCallback = exports.OktonAuthPage = exports.OktonLogin = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importStar(require("react"));
const lu_1 = require("react-icons/lu");
const auth_1 = require("../../auth");
const brand_1 = require("./brand");
const CredentialInput = ({ name, label, type, value, onChange, leftIcon, autoComplete, }) => {
    const color = (0, react_1.useColorModeValue)("gray.700", "white");
    const colorIcon = (0, react_1.useColorModeValue)("blue.500", "white");
    const [visiblePassword, visiblePasswordActions] = (0, react_1.useBoolean)(false);
    const isPassword = type === "password";
    return (react_2.default.createElement(react_1.FormControl, null,
        react_2.default.createElement(react_1.FormLabel, { color: color, fontSize: "sm", fontWeight: "light", htmlFor: name }, label),
        react_2.default.createElement(react_1.InputGroup, null,
            react_2.default.createElement(react_1.InputLeftElement, { pointerEvents: "none", children: react_2.default.createElement(react_1.Icon, { as: leftIcon, color: colorIcon, fontSize: 20, mt: "2", ml: "2" }) }),
            react_2.default.createElement(react_1.Input, { id: name, name: name, type: isPassword && visiblePassword ? "text" : type, value: value, onChange: (event) => onChange(event.target.value), autoComplete: autoComplete, fontWeight: "light", fontSize: "md", color: color, size: "lg", rounded: "2xl", pl: "12", pr: isPassword ? "12" : undefined }),
            isPassword && (react_2.default.createElement(react_1.InputRightElement, { children: react_2.default.createElement(react_1.Icon, { as: (visiblePassword ? lu_1.LuEye : lu_1.LuEyeClosed), color: colorIcon, cursor: "pointer", fontSize: 20, mt: "2", mr: "2", onClick: visiblePasswordActions.toggle }) })))));
};
var OktonLogin_1 = require("./OktonLogin");
Object.defineProperty(exports, "OktonLogin", { enumerable: true, get: function () { return OktonLogin_1.OktonLogin; } });
var OktonAuthPage_1 = require("./OktonAuthPage");
Object.defineProperty(exports, "OktonAuthPage", { enumerable: true, get: function () { return OktonAuthPage_1.OktonAuthPage; } });
const OktonAuthCallback = () => {
    const { bootstrap, completeLogin } = (0, auth_1.useOktonAuth)();
    const [error, setError] = react_2.default.useState();
    const started = react_2.default.useRef(false);
    react_2.default.useEffect(() => {
        if (!bootstrap || started.current)
            return;
        started.current = true;
        completeLogin()
            .then(() => window.location.replace(bootstrap.auth.postLoginUrl || "/"))
            .catch((err) => setError(err instanceof Error ? err.message : "Falha ao concluir login."));
    }, [bootstrap, completeLogin]);
    return (react_2.default.createElement(react_1.Flex, { minH: "100vh", align: "center", justify: "center", flexDir: "column" }, error ? (react_2.default.createElement(react_1.Text, { color: "red.500" }, error)) : (react_2.default.createElement(react_2.default.Fragment, null,
        react_2.default.createElement(react_1.Spinner, { color: "blue.500" }),
        react_2.default.createElement(react_1.Text, { mt: "4" }, "Concluindo acesso...")))));
};
exports.OktonAuthCallback = OktonAuthCallback;
const OktonForgotPassword = () => {
    const { bootstrap, requestPasswordReset, isLoading } = (0, auth_1.useOktonAuth)();
    const [email, setEmail] = (0, react_2.useState)("");
    const [isSubmitting, setIsSubmitting] = (0, react_2.useState)(false);
    const [message, setMessage] = (0, react_2.useState)();
    const [formError, setFormError] = (0, react_2.useState)();
    const isWideVersion = (0, react_1.useBreakpointValue)({
        base: false,
        sm: true,
        md: true,
        lg: true,
    });
    const { colorMode, toggleColorMode } = (0, react_1.useColorMode)();
    const bg = (0, react_1.useColorModeValue)("blue.600", "gray.800");
    const bgWideVersion = (0, react_1.useColorModeValue)("white", "gray.800");
    const bgForm = (0, react_1.useColorModeValue)("white", "gray.700");
    const bgFormWideVersion = (0, react_1.useColorModeValue)("white", "gray.800");
    const color = (0, react_1.useColorModeValue)("gray.700", "white");
    const colorIcon = (0, react_1.useColorModeValue)("blue.500", "white");
    const link = (0, react_1.useColorModeValue)("blue.600", "white");
    const successBg = (0, react_1.useColorModeValue)("green.50", "green.900");
    const successColor = (0, react_1.useColorModeValue)("green.700", "green.100");
    const containerBg = isWideVersion ? bg : bgWideVersion;
    const formBg = isWideVersion ? bgForm : bgFormWideVersion;
    const showLogoWhite = Boolean(isWideVersion || colorMode !== "light");
    const showLogoBlue = Boolean(colorMode === "light" && !isWideVersion);
    const systemNameColor = showLogoBlue ? "blue.600" : "white";
    const systemNameMutedColor = showLogoBlue ? "gray.500" : "whiteAlpha.800";
    async function handleForgot(event) {
        event.preventDefault();
        setFormError(undefined);
        setMessage(undefined);
        if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
            setFormError("Informe um e-mail válido.");
            return;
        }
        setIsSubmitting(true);
        try {
            setMessage(await requestPasswordReset(email));
        }
        catch (err) {
            setFormError(err instanceof Error
                ? err.message
                : "Não foi possível solicitar a recuperação de senha.");
        }
        finally {
            setIsSubmitting(false);
        }
    }
    return (react_2.default.createElement(react_1.Flex, { w: "100vw", h: "100vh", flexDir: "column", align: "center", justify: "center", bg: containerBg, px: ["4", "0"] },
        react_2.default.createElement(react_1.Flex, { flexDir: "column", align: "center", mb: "8" },
            showLogoWhite && (react_2.default.createElement(react_1.Image, { src: brand_1.oktonLogoWhite, alt: "Okton - Sistemas Empresariais", w: "250px", maxH: "80px", objectFit: "contain" })),
            showLogoBlue && (react_2.default.createElement(react_1.Image, { src: brand_1.oktonLogoBlue, alt: "Okton - Sistemas Empresariais", w: "250px", maxH: "95px", objectFit: "contain" })),
            (bootstrap === null || bootstrap === void 0 ? void 0 : bootstrap.system.name) && (react_2.default.createElement(react_1.Flex, { flexDir: "column", align: "center", mt: "3" },
                react_2.default.createElement(react_1.Text, { color: systemNameColor, fontSize: ["sm", "md"], fontWeight: "500", letterSpacing: "0.08em", lineHeight: "short", textAlign: "center", textTransform: "uppercase" }, bootstrap.system.name),
                react_2.default.createElement(react_1.Flex, { mt: "2", w: "32px", h: "3px", rounded: "full", bg: "yellow.400", opacity: 0.95 }),
                bootstrap.system.description && (react_2.default.createElement(react_1.Text, { mt: "2", maxW: "360px", color: systemNameMutedColor, fontSize: "xs", lineHeight: "short", textAlign: "center", noOfLines: 1 }, bootstrap.system.description))))),
        react_2.default.createElement(react_1.Flex, { as: "form", width: "100%", maxWidth: 488, flexDir: "column", p: "8", rounded: "2xl", boxShadow: "xs", bg: formBg, onSubmit: handleForgot },
            react_2.default.createElement(react_1.Stack, { spacing: "4" },
                react_2.default.createElement(react_1.Flex, { justify: "space-between", align: "center" },
                    react_2.default.createElement(react_1.Flex, { w: "22px" }),
                    react_2.default.createElement(react_1.Text, { color: color, fontSize: "sm", fontWeight: "medium", align: "center" }, "N\u00E3o consegue entrar?"),
                    react_2.default.createElement(react_1.Icon, { as: (colorMode === "light" ? lu_1.LuSun : lu_1.LuMoon), color: colorIcon, fontSize: "22", onClick: toggleColorMode, cursor: "pointer" })),
                react_2.default.createElement(CredentialInput, { name: "email", type: "email", label: "A gente vai mandar um link de recupera\u00E7\u00E3o para", value: email, onChange: setEmail, leftIcon: lu_1.LuAtSign, autoComplete: "email" }),
                formError && (react_2.default.createElement(react_1.Text, { fontSize: "sm", color: "red.500", textAlign: "center" }, formError)),
                message && (react_2.default.createElement(react_1.Flex, { bg: successBg, color: successColor, rounded: "xl", px: "4", py: "3" },
                    react_2.default.createElement(react_1.Text, { color: successColor, fontSize: "sm" }, message)))),
            react_2.default.createElement(react_1.Button, { type: "submit", mt: "6", isLoading: isLoading || isSubmitting, isDisabled: !bootstrap || !email }, "Enviar link de recupera\u00E7\u00E3o"),
            react_2.default.createElement(react_1.Divider, { my: "6", borderColor: color, opacity: 0.35 }),
            react_2.default.createElement(react_1.HStack, { justify: "center" },
                react_2.default.createElement(react_1.Link, { color: link, fontSize: "sm", href: (bootstrap === null || bootstrap === void 0 ? void 0 : bootstrap.auth.postLogoutUrl) || "/login" }, "Voltar \u00E0 p\u00E1gina de entrada")))));
};
exports.OktonForgotPassword = OktonForgotPassword;
//# sourceMappingURL=index.js.map